module.exports = __webpack_public_path__ + "171aaaddfd8d9ebedb644656cb303999.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/default-owl-9.png
// module id = 554
// module chunks = 0